import styled from 'styled-components';

import { ReactComponent as DeleteIcon } from 'assets/images/delete.svg';
import { fontFamily } from 'components/styles/_variables';

export const Wrapper = styled.div`
  margin-bottom: ${({ mb }) => mb}px;
  margin-top: ${({ mt }) => mt}px;
  margin-left: ${({ ml }) => ml}px;
  display: flex;
  justify-content: space-between;
  position: ${({ position }) => position};
  right: ${({ right }) => right}px;

  width: ${({ standardWidth = true }) => (standardWidth ? '320px' : 'auto')};
`;

export const DeleteIconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  cursor: pointer;
`;

export const Title = styled.span`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  line-height: 2.13;
  letter-spacing: -0.27px;
  color: #636262;
}
`;

const DeletableItem = ({ standardWidth = true, right = 0, title, onClickDelete, position = 'relative' }) => {
  return (
    <Wrapper standardWidth={standardWidth} mb={0} right={right} position={position}>
      <Title>{title}</Title>
      <DeleteIconWrapper role='presentation' onClick={onClickDelete}>
        <DeleteIcon />
      </DeleteIconWrapper>
    </Wrapper>
  );
};

export default DeletableItem;
